/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat Social Media viewer — platform distribution, table + per-platform drilldown. */
(function () {
  "use strict";
  /* Answers "is the deployed file the new one?" without a deploy archaeology session. If the
     console does not say 1.0.0, a stale edge copy is being served — purge the CDN. */
  try { (window.GS_BUILD = window.GS_BUILD || {})["social-media"] = "1.1.0"; } catch (e) {}
  function ic(n) { return (window.GSIcons && GSIcons.svg) ? (GSIcons.svg(n, 16) + " ") : ""; }
  var root;
  function q(n) { return root ? root.querySelector('[data-d="' + n + '"]') : null; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function dur(s) { s = +s || 0; if (s < 60) return s + "s"; var m = Math.floor(s / 60); return m + "m " + (s % 60) + "s"; }

  function ready(fn) {
    var done = false; function go() { if (done) return; done = true; fn(); }
    document.addEventListener("gs:ready", go, { once: true });
    var n = 0, t = setInterval(function () { if (window.GS && GS.api && GS.site) { clearInterval(t); go(); } else if (++n > 200) clearInterval(t); }, 30);
    if (window.GS && GS.api && GS.site) go();
  }

  var DATA = null;

  function render(d) {
    DATA = d;
    var tot = d.totals || {}, plats = d.platforms || [];
    q("k-sessions").textContent = (tot.social_sessions || 0).toLocaleString();
    q("k-share").textContent = (tot.social_share || 0) + "%";
    q("k-platforms").textContent = (tot.platforms || 0).toLocaleString();
    q("k-top").textContent = d.top_platform || "\u2014";
    var note = q("dist-note"); if (note) note.textContent = (tot.social_sessions || 0).toLocaleString() + " of " + (tot.total_sessions || 0).toLocaleString() + " sessions";

    var dist = q("dist");
    dist.innerHTML = plats.length ? plats.map(function (p) {
      return '<div class="so-drow"><span class="so-dl">' + ic(p.name) + esc(p.name) + "</span>" +
        '<span class="so-dt"><i style="width:' + Math.max(2, p.share) + "%;background:" + esc(p.color) + '"></i></span>' +
        '<span class="so-dv"><b>' + p.share + "%</b> \u00b7 " + p.sessions.toLocaleString() + "</span></div>";
    }).join("") : '<div class="empty">'+TR('social.f2.no_social_traffic_in_this_range')+'</div>';

    var tb = q("tbody");
    function socRow(p, i) {
      return '<tr data-i="' + i + '"><td class="pn"><span class="pdot" style="background:' + esc(p.color) + '"></span>' + ic(p.name) + esc(p.name) + "</td>" +
        '<td class="r num">' + p.visitors.toLocaleString() + "</td>" +
        '<td class="r num">' + p.sessions.toLocaleString() + "</td>" +
        '<td class="r num">' + p.pageviews.toLocaleString() + "</td>" +
        '<td class="r num">' + p.pages_per_session + "</td>" +
        '<td class="r">' + dur(p.avg_seconds) + "</td>" +
        '<td class="r conv num">' + p.conv_pct + "%</td>" +
        '<td class="r num">' + p.share + "%</td></tr>";
    }
    if (window.GSMore) GSMore.mount({ container: tb, table: true, colspan: 8, items: plats, pageSize: 20, emptyText: TR('social.f2.no_social_traffic_in_this_range'), render: socRow });
    else tb.innerHTML = plats.length ? plats.map(socRow).join("") : '<tr><td colspan="8" class="empty">'+TR('social.f2.no_social_traffic_in_this_range')+'</td></tr>';
    // Delegated: rows revealed by "Load more" stay clickable.
    if (!tb._socDelegated) { tb._socDelegated = 1;
      tb.addEventListener("click", function (e) { var tr = e.target.closest && e.target.closest("tr[data-i]"); if (tr) drill(+tr.getAttribute("data-i")); }); }
  }

  function drill(i) {
    var p = (DATA && DATA.platforms && DATA.platforms[i]); if (!p) return;
    var box = q("drill"); if (!box) return;
    q("drill-name").innerHTML = ic(p.name) + esc(p.name);
    q("drill-refs").innerHTML = (p.top_referrers && p.top_referrers.length)
      ? p.top_referrers.map(function (r) { return '<div class="so-ref"><span class="rh">' + esc(r.host) + '</span><span class="rv">' + r.sessions.toLocaleString() + "</span></div>"; }).join("")
      : '<div class="empty">'+TR('social.referrer_stripped_app_links')+'</div>';
    q("drill-types").innerHTML = (p.referral_types || []).map(function (t) {
      return '<div class="so-type"><span class="th">' + esc(t.label) + '</span><span class="tv">' + t.sessions.toLocaleString() + "</span></div>";
    }).join("");
    box.hidden = false; box.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }
  /* ── Social Influence Intelligence ──────────────────────────────────────────
     Platform crossed with behaviour. Two platforms can send identical session
     counts and completely different people; this is the panel that shows it. */
  var SI_STAGES = ["exploration","evaluation","comparison","commitment"];
  var SI = { AC:"#1FA463", RD:"#DC2626", PU:"#6C4BE8", BL:"#2A6FE8", MU:"#8C95A1" };

  function siNum(n){ n=+n||0; return n>=1e6?(n/1e6).toFixed(1)+"M":n>=1e3?(n/1e3).toFixed(1)+"k":String(n); }
  function siTriad(b){
    if(!b) return '<div class="gs-muted small">'+TR('social.g.no_behavioural_scores_yet')+'</div>';
    return [[TR('social.g.intent'),b.intent,SI.AC],[TR('social.g.friction'),b.frustration,SI.RD],[TR('social.g.attention'),b.attention,SI.PU]]
      .map(function(t){ return '<div class="si-tri"><span>'+t[0]+'</span><i><b style="width:'
        +Math.max(0,Math.min(100,t[1]))+'%;background:'+t[2]+'"></b></i><em>'+t[1]+'</em></div>'; }).join("");
  }
  function siCards(d){
    var host=q("si-cards"); if(!host) return;
    var rows=d.platforms||[];
    if(!rows.length){ host.innerHTML='<div class="empty">'+TR('social.f2.no_social_traffic_in_this_range')+'</div>'; return; }
    var note=q("si-note");
    if(note && !d.has_behaviour && d.notes && d.notes.behaviour) note.textContent=d.notes.behaviour;
    host.innerHTML=rows.map(function(r){
      var p=(r.personas&&r.personas[0])||null;
      var land=(r.landing||[]).slice(0,3).map(function(l){
        return '<a class="si-land" href="/heatmaps?page='+encodeURIComponent(l.path)+'"><span>'
             +esc(l.path)+'</span><b>'+siNum(l.sessions)+'</b></a>'; }).join("");
      return '<article class="si-card">'
        +'<div class="si-card-h">'+ic(r.key)+'<b>'+esc(r.key)+'</b><span class="si-share" style="color:'+(r.color||SI.MU)+'">'+r.share+'%</span></div>'
        +'<div class="si-stats"><span>'+siNum(r.sessions)+' sessions</span><span>'+siNum(r.visitors)+' visitors</span><span>'+r.pages_per_session+' pages/visit</span></div>'
        +'<div class="si-triad">'+siTriad(r.behaviour)+'</div>'
        +(p?'<div class="si-persona">'+TR('social.g.mostly')+'<b>'+esc(p.label)+'</b> · '+p.pct+'%</div>':"")
        +(land?'<div class="si-lands">'+land+'</div>':"")
        +'</article>';
    }).join("");
  }
  function siJourney(d){
    var host=q("si-journey"); if(!host) return;
    var rows=(d.platforms||[]).filter(function(r){ return r.journeys && r.journeys.length; });
    if(!rows.length){ host.innerHTML='<div class="gs-muted small">'+
      (d.has_behaviour?TR('social.p.no_journey_stages_scored_in_this_ran'):((d.notes&&d.notes.behaviour)||""))+'</div>'; return; }
    var col={exploration:"#8C95A1",evaluation:SI.BL,comparison:SI.PU,commitment:SI.AC};
    host.innerHTML=rows.map(function(r){
      var by={}; r.journeys.forEach(function(j){ by[String(j.label).toLowerCase()]=j.pct; });
      var segs=SI_STAGES.filter(function(s){return by[s];}).map(function(s){
        return '<i style="width:'+by[s]+'%;background:'+col[s]+'" title="'+s+' '+by[s]+'%"></i>'; }).join("");
      var top=r.journeys[0];
      return '<div class="si-jrow"><div class="si-jh">'+ic(r.key)+'<b>'+esc(r.key)+'</b>'
        +'<span class="gs-muted">'+esc(top.label)+' '+top.pct+'%</span></div>'
        +'<div class="si-jbar">'+segs+'</div></div>';
    }).join("")
    +'<div class="si-jkey">'+SI_STAGES.map(function(s){
        return '<span><i style="background:'+col[s]+'"></i>'+s+'</span>'; }).join("")+'</div>';
  }
  function siFail(msg){
    var w=q("si"); if(!w) return; w.hidden=false;
    var h=q("si-cards"); if(h) h.innerHTML='<div class="empty">'+esc(msg)+'</div>';
  }
  function loadIntel(){
    var wrap=q("si");
    if(!wrap){ if(window.console) console.warn('[social-media] no [data-d="si"] — template not deployed?'); return; }
    if(!window.GS||!GS.api){ siFail(TR('social.g.ghoststat_app_scripts_did_not_load')); return; }
    if(!GS.site) return;
    GS.api("/plugin/social-media/intel?site="+encodeURIComponent(GS.site)+"&from="+RANGE.from+"&to="+RANGE.to)
      .then(function(r){
        var d=(r&&r.data)?r.data:r;
        if(!d){ siFail(TR('social.g.no_response_from_the_intel_endpoint')); return; }
        if(d.gated){ siFail(TR('social.f3.social_influence_isn_t_available_o')); return; }
        if(d.error==="plugin_not_loaded"){ siFail(TR('social.f3.social_media_analytics_isn_t_enabl')); return; }
        if(!d.platforms){ siFail(TR('social.g.the_intel_endpoint_returned_nothing_')); return; }
        wrap.hidden=false;
        var t=q("si-tot");
        if(t&&d.totals) t.innerHTML=siNum(d.totals.sessions)+" sessions &middot; "+siNum(d.totals.visitors)+" visitors";
        siCards(d); siJourney(d);
      })
      .catch(function(e){
        siFail(TR('social.p.could_not_load_social_influence')+((e&&e.message)||"request failed")+").");
        if(window.console) console.warn("[social-media] intel request failed", e);
      });
  }


  function load() {
    loadIntel();
    GS.api("/plugin/social-media/platforms?site=" + encodeURIComponent(GS.site) + "&from=" + RANGE.from + "&to=" + RANGE.to).then(function (r) {
      if (r.ok && r.data) render(r.data);
    });
  }

  function _ymd(d) { return d.getUTCFullYear() + "-" + ("0" + (d.getUTCMonth() + 1)).slice(-2) + "-" + ("0" + d.getUTCDate()).slice(-2); }
  function _today() { var t = new Date(); return new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate())); }
  function T(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function preset(days) { var to = _today(), from = new Date(to.getTime() - (days - 1) * 86400000); var lbl = { 7: T("an.last7"), 30: T("an.last30"), 90: T("an.last90"), 365: T("an.last12mo") }[days] || T("an.lastndays",{n:days}); return { from: _ymd(from), to: _ymd(to), label: lbl, preset: String(days) }; }
  var RANGE = (function () { try { var s = JSON.parse(localStorage.getItem("gs_social_range") || "null"); /* A stored preset is a RULE ("last 30 days"), not a fixed window. Restoring its
     absolute from/to means "last 30 days" quietly becomes "the 30 days ending whenever
     you last touched the picker" — today falls outside the range, the page looks stale,
     and Refresh re-queries the same dead window forever. Re-anchor presets to today;
     a CUSTOM range is genuinely absolute and is kept as stored. */
  if (s && s.preset) return preset(+s.preset);
  if (s && s.from && s.to) return s; } catch (e) {} return preset(30); })();
  function saveRange() { try { localStorage.setItem("gs_social_range", JSON.stringify(RANGE)); } catch (e) {} }

  function initRange() {
    var btn = q("rangeBtn"), menu = q("rangeMenu"), lab = q("range-label"); if (!btn || !menu) return;
    if (lab && RANGE.label) lab.textContent = RANGE.label;
    function sync() { menu.querySelectorAll(".rm[data-preset]").forEach(function (x) { x.classList.toggle("on", x.getAttribute("data-preset") === RANGE.preset); }); }
    sync();
    btn.addEventListener("click", function (e) { if (menu.contains(e.target) && e.target !== btn) return; e.stopPropagation(); var open = menu.style.display !== "none"; menu.style.display = open ? "none" : "block"; });
    document.addEventListener("click", function () { menu.style.display = "none"; });
    menu.addEventListener("click", function (e) { e.stopPropagation(); });
    menu.querySelectorAll(".rm[data-preset]").forEach(function (b) { b.addEventListener("click", function () { RANGE = preset(+b.getAttribute("data-preset")); if (lab) lab.textContent = RANGE.label; saveRange(); menu.style.display = "none"; sync(); load(); }); });
    // custom range: prefill the date fields when opening, apply on the button
    btn.addEventListener("click", function () { var cf = menu.querySelector('[data-rp="from"]'), ct = menu.querySelector('[data-rp="to"]'); if (cf && RANGE.from) cf.value = RANGE.from; if (ct && RANGE.to) ct.value = RANGE.to; });
    var ap = menu.querySelector('[data-rp="apply"]');
    if (ap) ap.addEventListener("click", function () {
      var ff = (menu.querySelector('[data-rp="from"]') || {}).value, tt = (menu.querySelector('[data-rp="to"]') || {}).value;
      if (!ff || !tt) return; if (ff > tt) { var x = ff; ff = tt; tt = x; }
      RANGE = { from: ff, to: tt, label: ff + " \u2192 " + tt, preset: null };
      if (lab) lab.textContent = RANGE.label; saveRange(); menu.style.display = "none"; sync(); load();
    });
  }
  function init() {
    root = document.querySelector('[data-d="root"]'); if (!root) return;
    var rf = q("refresh"); if (rf) rf.addEventListener("click", load);
    var dc = q("drill-close"); if (dc) dc.addEventListener("click", function () { q("drill").hidden = true; });
    initRange(); load();
  }
  ready(init);
})();
